import { collections } from "@/mocks/gallery";

export default function Collections() {
  return (
    <section id="collections" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-book-open-line"></i>
            Series Albums
          </span>
          <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            系列画集
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            收录画师的整本作品,在连载中展开完整而连贯的世界。
          </p>
        </div>
        <a
          href="#artists"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          查看全部画集
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {collections.map((c) => (
          <article
            key={c.id}
            className="group overflow-hidden rounded-lg bg-background-100"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={c.cover}
                alt={`${c.name}·娜美同人画集封面`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/65 to-transparent px-4 pb-3 pt-8">
                <span className="text-xs text-background-50">共 {c.count} 幅</span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-950">{c.name}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}